import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OoPagesComponent } from './oo-pages/oo-pages.component';

const routes: Routes = [{path:'',component:OoPagesComponent, children: [
  // {path: 'bids', loadChildren: () => import('./../bids/bids.module').then(m => m.BidsModule) },
    {path: 'dashboard', loadChildren: () => import('./../dashboard/dashboard.module').then(m => m.DashboardModule) },
    {path: 'profile', loadChildren: () => import('./../my-profile/my-profile.module').then(m => m.MyProfileModule) },
  //   {path: 'project', loadChildren: () => import('./../projects/projects.module').then(m => m.ProjectsModule)},
  //   {path: 'purchase-orders', loadChildren: () => import('./../purchase-orders/purchase-orders.module').then(m => m.PurchaseOrdersModule)},
    // {path: 'schedule', loadChildren: () => import('./../schedule/schedule.module').then(m => m.ScheduleModule)},
    {path: 'change-password', loadChildren: () => import('./../change-password/change-password.module').then(m => m.ChangePasswordModule)}
]}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OoPagesRoutingModule { }
